import { Skeleton } from "@/components/ui/skeleton"; // Assuming you have the ShadCN Skeleton component

const IndivStaffPageSkeleton = () => {
  return (
    <div className="flex flex-col h-[100vh] w-full p-5 gap-5">
      <Skeleton className="h-4/6 w-full " />
      <div className="h-2/6 w-full flex gap-5">
        <Skeleton className="h-full w-full" />
        <Skeleton className="h-full w-full" />
      </div>
    </div>
  );
};

export default IndivStaffPageSkeleton;
